<template>
  <BaseSimpleCard
    :button-back-left="true"
    :button-back-left-route="getRouteBackLeft()"
    title="Compte rendu"
  >
    <template #cta>
      <div class="flex flex-row space-x-2">
        <button class="btn btn-primary flex space-x-2" @click="mReloadIFrame">
          <font-awesome-icon :icon="['fal', 'sync']" />
        </button>
        <!--        <button class='btn btn-primary flex space-x-2' @click='saveAsAttachment'>-->
        <!--          <font-awesome-icon :icon='["fal","arrow-square-down"]' />-->
        <!--        </button >-->
      </div>
    </template>

    <template #default>
      <div class="flex h-full">
        <IFramePdf ref="iframe_doc" :src="cUrlDocument" />
      </div>
    </template>
  </BaseSimpleCard>
</template>

<script>
import { baseURL } from '@u/apiClient'
import VuePdfEmbed from 'vue-pdf-embed'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ReportPlanningDocument',
  components: {
    VuePdfEmbed
  },
  computed: {
    ...mapGetters({ auth: 'auth/getAuth' }),
    cUrlDocument() {
      const start_date = this.$route.params.start_date
      const end_date = this.$route.params.end_date

      let filter = {}
      filter['start_date'] = start_date
      filter['end_date'] = end_date
      filter['responsible'] = this.auth.full_name
      filter['lang'] = this.auth.language

      return (
        baseURL +
        'api/planning/report-planning/?filter=' +
        JSON.stringify(filter)
      )
    }
  },
  methods: {
    ...mapActions({
      saveDocumentAsAttachment: 'document/saveDocumentAsAttachment'
    }),
    getRouteBackLeft() {
      return { name: 'report_planning_route' }
    },
    mReloadIFrame() {
      const iframe = this.$el.querySelector('iframe')
      // Reassigning the same URL reloads the PDF.
      if (iframe) iframe.setAttribute('src', iframe.getAttribute('src'))
    }
  }
}
</script>
